<template>
  <div v-if="projectAlerts.length" class="d-contents">
    <div v-for="alert in projectAlerts" :key="alert.id" class="d-contents">
      <div v-if="get(alert, 'marked_up_content.blocks[0].data.text')" class="d-contents">
        <AlertMessage @close="closeAlert(alert.id)">
          <span v-html="alert.marked_up_content.blocks[0].data.text" />
        </AlertMessage>
      </div>
    </div>
  </div>
</template>

<script>
  import AlertMessage from '@/components/alerts/AlertMessage';
  import factory from '@/utils/api/factory';
  import get from 'lodash.get';
  import projectAlertsSubscription from '@/gql/alerts/project-alerts.graphql';
  import request from '@/utils/api/request';

  export default {
    name: 'ProjectAlertBlock',
    components: {
      AlertMessage,
    },
    apollo: {
      $subscribe: {
        alerts() {
          return {
            query: projectAlertsSubscription,
            variables() {
              return {
                project_id: this.projectId,
              };
            },
            result() {
              this.uploadAlerts();
            },
          };
        },
      },
    },
    data() {
      return {
        projectAlerts: [],
      };
    },
    computed: {
      projectId() {
        return this.$route.params.id;
      },
    },
    methods: {
      async uploadAlerts() {
        try {
          let { data } = await factory('alerts').index({
            context: 'project',
            project_id: this.projectId,
          });
          this.projectAlerts = data;
        } catch (e) {
          console.error(e);
        }
      },
      async closeAlert(id) {
        try {
          this.projectAlerts = this.projectAlerts.filter((alert) => alert.id !== id);
          await request.post(`/alerts/${id}/read/`);
        } catch (e) {
          console.error(e);
        }
      },
      get,
    },
  };
</script>
